
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"adminIdentityFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoginAdmin"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"browserNotification"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chainID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"desktopNotification"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dispensaryId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emailNotifications"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emailOptIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allLocations"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analytics"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"driver"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enterpriseAdmin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enterpriseSpecials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manageAds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"managePersonalization"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"menu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"menuReview"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"superMenuReview"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"promote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"settings"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DevLoginAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devLoginAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"adminIdentityFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":877}};
    doc.loc.source = {"body":"# region: ../fragments/admin-identity-fragment.gql\nfragment adminIdentityFragment on LoginAdmin {\n  accessToken\n  user {\n    _id\n    createdAt\n    emails {\n      address\n    }\n    profile {\n      browserNotification\n      chainID\n      desktopNotification\n      dispensaryId\n      emailNotifications\n      emailOptIn\n      firstName\n      fullName\n      lastName\n      permissions {\n        allLocations\n        billing\n        analytics\n        customers\n        driver\n        enterpriseAdmin\n        enterpriseSpecials\n        manageAds\n        managePersonalization\n        menu\n        menuReview\n        superMenuReview\n        orders\n        promote\n        settings\n        users\n        tasks\n      }\n      phone\n      type\n    }\n  }\n}\n\n# endregion\n\nmutation DevLoginAdmin($accountId: ID!) {\n  devLoginAdmin(accountId: $accountId) {\n    ...adminIdentityFragment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["adminIdentityFragment"] = oneQuery(doc, "adminIdentityFragment");
        
        module.exports["DevLoginAdmin"] = oneQuery(doc, "DevLoginAdmin");
        
